import { Outlet, createRootRoute } from "@tanstack/react-router";

import { LoadingPage } from "@/components/layout";
import { NotFoundPage } from "@/components/not-found-page";
import { usePageTracking } from "@/hooks/use-page-tracking";
import { useAuthStore } from "@/stores/auth.store";

export const Route = createRootRoute({
  component: () => Root(),
  notFoundComponent: () => NotFoundPage()
});

const Root = () => {
  usePageTracking();
  const { loading } = useAuthStore();

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="relative min-h-screen max-w-screen">
      <div className="bg-primary-50 fixed inset-0 z-[-1]" />
      <div className="relative flex flex-col h-screen w-full">
        <Outlet />
      </div>
    </div>
  );
};
